<!--
  ~ VNCcontact+ : A new level of contact management
  ~ Copyright (C) 2015-2020 VNC – Virtual Network Consult AG (info@vnc.biz)
  ~
  ~ This program is free software: you can redistribute it and/or modify
  ~ it under the terms of the GNU Affero General Public License as published by
  ~ the Free Software Foundation, version 3 of the License.
  ~
  ~ This program is distributed in the hope that it will be useful,
  ~ but WITHOUT ANY WARRANTY; without even the implied warranty of
  ~ MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
  ~ GNU Affero General Public License for more details.
  ~
  ~ You should have received a copy of the GNU Affero General Public License
  ~ along with this program. Look for COPYING file in the top folder.
  ~ If not, see http://www.gnu.org/licenses/.
  -->

  <div class="contact-dialog">
    <div class="contact__dialog-header">
        <div class="mobile-back-button">
            <button mat-button (click)="close()">
                <mat-icon class="mdi-20px" fontSet="mdi" fontIcon="mdi-arrow-left"></mat-icon>
            </button>
        </div>
        <div class="header_lbl disable-select">
            {{ 'ADVANCED_SEARCH' | translate }}
        </div>
        <div>
            <button mat-button (click)="removeAdvanceSearchConfig()">
                <mat-icon class="disable-select">cached</mat-icon>
            </button>
        </div>
        <div class="desktop-close-button">
            <button mat-button (click)="close()">
                <mat-icon class="disable-select">close</mat-icon>
            </button>
        </div>
        
    </div>
    <div class="contact__dialog-body">
        <div class="content">
            <div class="item" (click)="openSearchInApps()">
                <div class="search-in">{{'SEARCH_IN_APPS' | translate }}</div>
                <div class="lists">{{searchApps}}</div>
            </div>
            <div class="item" (click)="searchInLists()">
                <div class="search-in">{{'SEARCH_IN_LISTS' | translate }}</div>
                <div class="lists" *ngIf="!!searchLists && searchLists.length === 0">{{'ALL_LIST' | translate }}</div>
                <div class="lists" *ngIf="!!searchLists && searchLists.length > 0">{{ searchListsItem }}</div>
            </div>
            <div class="item" (click)="searchInTags()">
                <div class="search-in">{{'SEARCH_IN_TAGS' | translate }}</div>
                <div class="lists" *ngIf="!!searchTags && searchTags.length === 0">{{'ALL_TAGS' | translate }}</div>
                <div class="lists" *ngIf="!!searchTags && searchTags.length > 0">{{ searchTagsItem }}</div>
            </div>
        </div>
    </div>
</div>